export const BARCODE_CLIPBOARD_LOCAL_STORAGE_KEY = 'pace-barcode-clipboard';
export const BARCODE_CLIPBOARD_CONCURRENT_STORAGE_KEY = 'pace-barcode-clipboard';

export interface BarcodeScanResult {
    text: string;
    format: string;
}
